import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import i18next from 'i18next';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { PapiDaSharedUserInfo, PapiError } from '@wix/da-papi-types';
import ddt from '@wix/da-ddt';
import { addErrorNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import {
  fetchDmCardData,
  fetchDmCardDataFailure,
  fetchDmCardDataSuccess,
} from '../../actions/room';
import { getActiveRoomItem } from '../../selectors/room';

function* handleFetchDmCardData(action: ReturnType<typeof fetchDmCardData>) {
  try {
    const roomItem: ReturnType<typeof getActiveRoomItem> = yield select(getActiveRoomItem);

    if (!roomItem?.dmUser?.username) {
      ddt.error('damz', 'No username found when fetching dm card data', roomItem);
      return;
    }

    const response: PapiDaSharedUserInfo = yield call(
      requestPuppy,
      {
        method: 'get',
        url: 'user/info',
        params: { username: roomItem?.dmUser?.username, expand: 'user.stats' },
      },
      undefined,
      'dashared'
    );

    if (!response || isApiError(response)) {
      const err = response as unknown as PapiError | undefined;
      yield put(
        fetchDmCardDataFailure(err?.errorDescription ?? i18next.t('damz:damz.drawer.fetch.error'))
      );
      return;
    }

    yield put(
      fetchDmCardDataSuccess(
        response.user.stats?.watchers ?? 0,
        response.deviationsCount ?? 0,
        response.user.isWatching ?? false
      )
    );
  } catch (error) {
    yield put(fetchDmCardDataFailure(i18next.t('damz:damz.drawer.fetch.error')));

    ddt.error('damz', 'Error fetching dm card data', error);
  }
}

function* handleFetchDmCardDataFailure(action: ReturnType<typeof fetchDmCardDataFailure>) {
  yield put(addErrorNotification(action.payload.error));
}

export function* roomDmCardDataSaga() {
  yield all([
    takeEvery(fetchDmCardData, handleFetchDmCardData),
    takeEvery(fetchDmCardDataFailure, handleFetchDmCardDataFailure),
  ]);
}
